import { Card } from "@/components/ui/card";
import Image from "next/image";
import Link from "next/link";
import { useParams } from "next/navigation";
import React from "react";

interface FractionCardProps {
  name: string;
  logo?: string;
  slug?: string;
  id: number;
}
const FractionCard = ({ name, logo, slug, id }: FractionCardProps) => {
  const { slug: electoralId } = useParams();
  return (
    <Link
      href={`/member?dapil=${electoralId}&fraksi=${id ?? slug}&from="fraksi"`}
    >
      <Card className="bg-fraction flex items-center justify-between gap-4 p-4">
        <h3 className="text-xl text-primary-700 font-semibold">{name}</h3>
        <Image
          src={logo ?? "/assets/images/no-image.png"}
          alt={name}
          width={400}
          height={200}
          className="h-24 w-20 object-contain"
        />
      </Card>
    </Link>
  );
};

export default FractionCard;
